import React from "react";

import { cx } from "class-variance-authority";

import * as theme from "./Row.css";

interface RowProps {
    selected?: boolean;
    children: React.ReactNode;
}
/**
 * Row component for use within other table components
 */
export function Row({ children, selected }: RowProps) {
    return (
        <tr className={cx(theme.row, selected && theme.selected)}>
            {children}
        </tr>
    );
}
